import React from 'react';

const SvgRoundedCorner = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 12a9 9 0 019-9h9v2h-9a7 7 0 000 14h9v2h-9a9 9 0 01-9-9z"
      fill="currentColor"
    />
  </svg>
);

export default SvgRoundedCorner;
